import { IFormConfigSectionQualifier } from "../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormSectionService } from "../../service/formconfiguration/FormSectionService";

export default class UpdateFormConfigSectionQualifierInteractor {
  private formSectionService: IFormSectionService;

  constructor(formSectionService) {
    this.formSectionService = formSectionService;
  }

  async execute(
    formTypeCode: string,
    id: number,
    formSectionId: number,
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ) {
    await this.formSectionService.updateFormConfigSectionQualifier(
      formTypeCode,
      id,
      formSectionId,
      formConfigSectionQualifier
    );
  }
}
